export default function initCountUp() {
  const stats = document.querySelectorAll('.infographic-item__stat');
  if (!stats.length) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const escape = (s) =>
    s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  const symbol = (s) => {
    if (!s) return '';
    if (/[a-z]/i.test(s)) return escape(s);
    return `<span class="infographic-item__stat-symbol">${escape(s)}</span>`;
  };

  const parse = (text) => {
    const m = text.match(/^(\D*?)(\d[\d,]*(?:\.\d+)?)(.*)$/s);
    if (!m) return null;
    const raw = m[2];
    return {
      prefix: m[1],
      suffix: m[3],
      value: parseFloat(raw.replace(/,/g, '')),
      decimals: raw.includes('.') ? raw.split('.')[1].length : 0,
      grouped: raw.includes(','),
    };
  };

  const number = (n, p) => {
    let s = n.toFixed(p.decimals);
    if (p.grouped) {
      const parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      s = parts.join('.');
    }
    return s;
  };

  const html = (n, p) => escape(p.prefix) + number(n, p) + symbol(p.suffix);

  stats.forEach((el) => {
    const finalText = el.textContent.trim();
    const parsed = parse(finalText);
    if (!parsed) return;

    el.innerHTML = html(parsed.value, parsed);

    if (!el.closest('.is-style-image-detail') || reduce) return;

    el.style.width = `${Math.ceil(el.getBoundingClientRect().width)}px`;
    el.style.textAlign = 'right';
    el.style.fontVariantNumeric = 'tabular-nums';

    const label = document.createElement('span');
    label.className = 'u-sr-only';
    label.textContent = finalText;

    const visual = document.createElement('span');
    visual.setAttribute('aria-hidden', 'true');
    visual.innerHTML = html(0, parsed);

    el.textContent = '';
    el.append(label, visual);

    const run = () => {
      const duration = 2400;
      const start = performance.now();
      const step = (now) => {
        const t = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - t, 1.4);
        visual.innerHTML = html(t < 1 ? parsed.value * eased : parsed.value, parsed);
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            run();
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5, rootMargin: '0px 0px -25% 0px' }
    );

    observer.observe(el);
  });
}
